import { HEADER, SHOW_FIXED_NAV, Show_Header, STREAM, HEADER_BG_PROPERTIES, Scroll_Header, } from "@frameworks/web/redux/interfaces/iHeader";
import store from "../store";
class HeaderActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getMenuData(headerEntityList) {
        return {
            type: HEADER,
            payload: {
                data: headerEntityList,
            },
        };
    }
    getStreamData(payload) {
        this.dispatch({
            type: STREAM,
            payload: {
                stream: payload,
            },
        });
    }
    getMarketData(payload) {
        return {
            type: STREAM,
            payload: {
                stream: payload,
            },
        };
    }
    RemoveHeaderData(showHeader) {
        this.dispatch({
            type: Show_Header,
            payload: { showHeader },
        });
    }
    setScrollHeader(scrollHeader) {
        this.dispatch({
            type: Scroll_Header,
            payload: { scrollHeader },
        });
    }
    HideFixedNavMob(showFixedNavMob) {
        this.dispatch({
            type: SHOW_FIXED_NAV,
            payload: { showFixedNavMob },
        });
    }
    headerBG_Properties(properties) {
        this.dispatch({
            type: HEADER_BG_PROPERTIES,
            payload: { headerBG_Properties: properties },
        });
    }
}
export default HeaderActions;
